import React from "react";

type FieldV4Props = {
  label: React.ReactNode;
  htmlFor: string;
  className?: string;
  children: React.ReactNode;
};

/** หัวข้อ + ช่องกรอก (hv4-label / hv4-input) */
const FieldV4 = (props: FieldV4Props) => (
  <div className={props.className}>
    <label className="hv4-label" htmlFor={props.htmlFor}>
      {props.label}
    </label>
    {props.children}
  </div>
);

FieldV4.displayName = "FieldV4";

export default FieldV4;
